/**
 * Personal Data Configuration
 * This file contains all configurable personal information used throughout the portfolio
 */

export const personalData = {
  name: "Jonathan Young",
  designation: "Full Stack Engineer & Web Developer",
  profileImage: "assets/images/profile.professional.portrait.jpg",
  email: "jyoung069631@gmail.com",
  address: "",
  resumeFile: "assets/jonathanyoung.cv.pdf",
  socialProfiles: [
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/iterating/",
      icon: "lab la-linkedin-in"
    },

    {
      name: "GitHub",
      url: "https://github.com/iterating",
      icon: "lab la-github"
    },
    {
      name: "Stack Overflow",
      url: "#",
      icon: "lab la-stack-overflow"
    }
  ]
};
